import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './containers/App/App';

ReactDOM.render(<App />, document.getElementById('root'));
